<template>
    <div>
        <el-drawer v-if="linkDialog.open && linkDialog.type === 'right'" append-to-body v-model="linkDialog.open" :size="linkDialog.size">
            <iframe allow="clipboard-read; clipboard-write"
                sandbox="allow-scripts allow-same-origin allow-popups allow-forms allow-downloads allow-modals"
                :src="linkDialog.url"
                style="height:90vh"
                frameborder="0"
                width="100%"
                height="100%"
            ></iframe>
        </el-drawer>
        
        <el-dialog v-if="linkDialog.open && linkDialog.type === 'dialog'" append-to-body v-model="linkDialog.open" :before-close="ckhandleClose" :width="linkDialog.size">
        <iframe allow="clipboard-read; clipboard-write"
                style="height:70vh"
                sandbox="allow-scripts allow-same-origin allow-popups allow-forms allow-downloads allow-modals"
                :src="linkDialog.url"
                frameborder="0"
                width="100%"
                height="100%"
            ></iframe>
        </el-dialog>
    </div>
</template>

<script>
export default {
    name: 'widget-link-open',
    props: {
        linkConfig: {
            type: Object,
            default: () => {
                return {
                    open: false,
                    terrace: false,
                    link: false,
                    field: '',
                    openConfig: 'original'
                }
            }
        },
        diaSize: {
            type: String,
            default: '80%'
        }
    },
    data () {
        return {
            linkDialog: {
                open: false,
                url: '',
                type: '',
                size: '50%'
            },
            dLo: false
        }
    },
    watch: {
        'linkDialog.open': {
            immediate: true,
            deep: true,
            handler (val) {
                if (!val && this.dLo) {
                    this.$emit('closeLink')
                }
            }
        }
    },
    methods: {
        ckhandleClose () {
            this.linkDialog = {
                open: false,
                url: '',
                type: '',
                size: '50%'
            }
        },
        open (str) {
            // 如果str是数组，找出其中的数组元素作为key，从对象元素中取第一个匹配的url
            if (Array.isArray(str)) {
                const keyArr = str.find(item => Array.isArray(item))
                const key = keyArr && keyArr[0]
                if (key) {
                    const objItem = str.find(item => !Array.isArray(item) && item[key] !== undefined)
                    str = objItem ? objItem[key] : ''
                } else {
                    str = ''
                }
            }
            switch (this.linkConfig.openConfig) {
                case 'original':
                    window.location.href = str
                    break
                case 'new':
                    window.open(str)
                    break
                case 'dialog':
                    console.log('弹窗内容待完善')
                    this.linkDialog = {
                        open: true,
                        url: str,
                        type: 'dialog',
                        size: this.diaSize || '80%'
                    }
                    this.dLo = true
                    break
                case 'right':
                    console.log('右侧内容待完善')
                    this.linkDialog = {
                        open: true,
                        url: str,
                        type: 'right',
                        size: this.diaSize || '80%'
                    }
                    this.dLo = true
                    break
            }
        }
    }
}
</script>
